import React, { memo } from 'react'
import { MenuItem } from '@mui/material'
import BlockIcon from '@mui/icons-material/Block'
import CreateIcon from '@mui/icons-material/Create'
import MoreButtonMenu from 'components/MoreButtonMenu'
import { Beenhere } from '@mui/icons-material'
import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import { USWorkField_User$key } from '__generated__/USWorkField_User.graphql'
import { USWorkField_UpdateUserMutation } from '__generated__/USWorkField_UpdateUserMutation.graphql'
import { useQuickCommit } from 'hooks/useQuickCommit'
import { useSnackbar } from 'hooks/redux'
import useStyles from './styles'

interface IUSWorkFieldProps {
  user: USWorkField_User$key
  editable: boolean
}

function USWorkField({ user: userFragmentRef, editable }: IUSWorkFieldProps) {
  const { classes } = useStyles()
  const { showSnackbarMessage } = useSnackbar()

  const user = useFragment(graphql`
    fragment USWorkField_User on User {
      profile {
        canWorkInTheUs
      }
    }
  `, userFragmentRef)

  const { execute } = useQuickCommit<USWorkField_UpdateUserMutation>(graphql`
    mutation USWorkField_UpdateUserMutation($input: UpdateUserInput!) {
      updateUser(input: $input) {
        user {
          profile {
            canWorkInTheUs
          }
        }
      }
    }
  `)

  const canWorkInTheUs = user.profile?.canWorkInTheUs || false

  const handleUpdateCanWorkInTheUs = (value: boolean) => {
    execute({
      input: {
        profile: {
          canWorkInTheUs: value,
        },
      },
    }).then((result) => {
      if (result?.updateUser?.user?.profile) {
        showSnackbarMessage('US work eligibility updated', { level: 'success' })
      }
    })
  }

  return (
    <div className={canWorkInTheUs ? classes.enabled : classes.disabled} data-cy="working">
      {canWorkInTheUs && (
        <React.Fragment>
          <Beenhere className={classes.icon} />US-eligible
        </React.Fragment>
      )}
      {!canWorkInTheUs && editable && (
        <React.Fragment>
          <BlockIcon className={classes.icon} />US-eligible
        </React.Fragment>
      )}
      {editable && (
        <MoreButtonMenu className={classes.editButton} icon={<CreateIcon />} data-cy="profile-us-work">
          <MenuItem
            onClick={() => handleUpdateCanWorkInTheUs(true)}
            data-cy="profile-us-work-yes"
          >
            I can work in the US
          </MenuItem>
          <MenuItem
            onClick={() => handleUpdateCanWorkInTheUs(false)}
            data-cy="profile-us-work-no"
          >
            I cannot work in the US
          </MenuItem>
        </MoreButtonMenu>
      )}
    </div>
  )
}

export default memo(USWorkField)
